var dataTables = function () {

    const wrapper = "<div class='responsive-outer' tabindex='0' role='region' aria-label='table'/>";

    // ensure resposnive tables are also processed correctly when loaded via AJAX
    $(document).on("ajaxComplete", function () {
        $('.m-wysiwyg table.responsive').each(function () {
            const $this = $(this);
            const $parent = $this.parent();

            if ($parent.hasClass('responsive-outer')) {
                $parent.attr({ tabindex: '0', role: 'region', 'aria-label': 'table' });
                return;
            }
            else {
                $this.wrap(wrapper)
            }
        });
    });

    if (!mando.isPageEditor()) {
        $('.m-wysiwyg table').wrap(wrapper);
        $('.filter tr td:first-child').each(function () {
            withoutNBSPHtml = $(this).html().replace(/(&nbsp;|&nbsp; | &nbsp;| &nbsp; )/g, "")
            $(this).html(withoutNBSPHtml);
        });
        $('.filter').DataTable({
            "paging": false,
            "info": false,
            "ordering": false,
            initComplete: function () {

                var api = this.api();

                var allColumns = api.columns().indexes().flatten();

                var column = api.column(allColumns[0]);

                var select = $('<select id="select-label"><option value="" selected="selected">All</option></select>')
                    .insertBefore($(this))
                    .on('change', function () {
                        var val = $.fn.dataTable.util.escapeRegex(
                            $(this).val()
                        ), regex = '^(' + val +')$';
                        column
                            .search(val ? regex : '', true, false)
                            .draw();    
                    });
                
                var columnData = column.data();                

                columnData.unique().sort().each(function (d, j) {
                    select.append('<option value="' + d + '">' + d + '</option>');
                });

                select.before('<label for="select-label">Show</label>');
            }
        });
    }
}